import { useEffect, useState } from 'react';
import './DashboardDemo.css';
import RescheduleTimes from '../../components/qualifier/RescheduleTimes';
import SubmitReschedule from '../../components/qualifier/SubmitReschedule';
import CalendarLinks from '../../components/qualifier/CalendarLinks';
import { getBuyerDemosRescheduled, refreshToken } from '../../utils/api';
import Spinner from '../../components/layout/Spinner';
import { FaEllipsisV, FaRegCalendarAlt } from 'react-icons/fa';
import { Link, useNavigate } from 'react-router-dom';
import FadeIn from '../../utils/fadein';
import { refresh, getCurrentUser } from '../../services/auth.service';
import { getTrimmedString, getBaseImageUrl } from '../../utils/utils';
import BuyerDecline from './BuyerDecline';

const BuyerDemosRescheduled = ({ buyerDeclinedReasons }) => {
  const [currentDemo, setCurrentDemo] = useState({});
  const [showDeclinedPopup, setShowDeclinedPopup] = useState(false);
  const [showReschedule, setShowReschedule] = useState(false);
  const [hasDemos, setHasDemos] = useState(true);
  const baseImageUrl = getBaseImageUrl();
  const [demos, setDemos] = useState([]);
  const [loaded, setLoaded] = useState(false);
  const [showSubMenu, setShowSubMenu] = useState(false);
  const navigate = useNavigate();

  async function handleToggleMenu(item){
    if (item.demo_id == currentDemo.demo_id){
      setCurrentDemo(item);
      setShowSubMenu(!showSubMenu);
    }

    else{
      setCurrentDemo(item);
      setShowSubMenu(true);
    }
  }

  useEffect(() => {
    async function loadDemos(){
      let res = await getBuyerDemosRescheduled();

      if (res.success){
        setDemos(res.data);
        setLoaded(true);
      }
    }

    loadDemos();
  }, []);

  useEffect(() => {
    let _democount = demos.filter(item => (item.seller_status === 'Approved' || item.seller_status === 'Rescheduled') && (item.buyer_status === 'Approved' || item.buyer_status === 'Rescheduled') && item.demo_status === 'Pending').length;

    if (_democount > 0)
      setHasDemos(true);
    else
      setHasDemos(false);
  }, [demos]);

  function declinedClickHandle(demo, id) {
    setCurrentDemo(demo);
    setShowDeclinedPopup(true);
    setShowSubMenu(false);
  }

  function handleRescheduleClick(item) {
    setCurrentDemo(item);
    setShowReschedule(true);
    setShowSubMenu(false);
  }

  return (
    <>
      {loaded === false && (
        <div className='center'>
          <Spinner />
        </div>
      )}

      {loaded && demos.length === 0 && (
        <div className='dashboarddemo__no-results'>
          <h2>No rescheduled demos found</h2>
        </div>
      )}

      {loaded && demos.length > 0 && (
        <div className="overflow-x-auto">
          <table className="min-w-full divide-y divide-gray-200 bg-white shadow-sm rounded-lg">
            <thead className="bg-gray-50">
              <tr>
                <th className="px-6 py-4 text-left text-sm font-medium text-gray-500">Company</th>
                <th className="px-6 py-4 text-left text-sm font-medium text-gray-500">Status</th>
                <th className="relative px-6 py-4"></th>
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-200">
              {loaded && demos.map((item) => (
                <tr className="hover:bg-gray-50 transition-colors">
                  <td className="px-6 py-4">
                    <div className="flex items-start space-x-4">
                      <div className="flex-shrink-0 h-12 w-12 rounded-full overflow-hidden border border-gray-200">
                        {item.logo && (
                          <img
                            src={baseImageUrl + 'companylogos/tr:di-@@companylogos@@default-buyer.png/' + item.logo}
                            alt={`${item.name} logo`}
                            className="h-full w-full object-cover"
                          />
                        )}
                      </div>
                      <div className="flex-1">
                        <h3 className="text-lg font-semibold text-gray-900">{item.company_name}</h3>
                        <div className="mt-1 space-y-2">
                          {item.seller_first_name && (
                            <p className="text-sm text-gray-600">
                              <span className="font-medium">Meeting with:</span>{' '}
                              {item.seller_first_name}{' '}
                              {item.seller_last_name && item.seller_last_name.substring(0,1).toUpperCase() + '.'}
                            </p>
                          )}
                          {item.seller_email && (
                            <p className="text-sm text-gray-600">
                              <span className="font-medium">Follow-up email:</span>{' '}
                              {item.seller_email}
                            </p>
                          )}
                          <p className="text-sm text-gray-600">
                            <span className="font-medium">Original date:</span>{' '}
                            <span className="text-gray-900">
                              {item.demo_date ? new Date(item.demo_date).toLocaleDateString() : 'No times have been set'}
                            </span>
                          </p>
                        </div>
                      </div>
                    </div>
                  </td>
                  <td className="px-6 py-4">
                    {item.buyer_status === 'Rescheduled' && item.seller_status === 'Approved' && (
                      <div className="inline-flex items-center px-3 py-1 rounded-full text-sm font-medium bg-blue-50 text-blue-700">
                        Awaiting confirmation
                      </div>
                    )}
                    {item.seller_status === 'Rescheduled' && (
                      <button
                        onClick={() => handleRescheduleClick(item)}
                        className="inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md shadow-sm text-white bg-purple-600 hover:bg-purple-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-purple-500"
                      >
                        Submit New Times
                      </button>
                    )}
                  </td>
                  <td className="px-6 py-4 text-right">
                    <div className="relative">
                      <button onClick={() => handleToggleMenu(item)} className="text-gray-400 hover:text-gray-600">
                        <FaEllipsisV className="h-5 w-5" />
                      </button>
                      {showSubMenu && currentDemo.demo_id === item.demo_id && (
                          <div className="absolute top-[-20px] right-[40px] mt-2 w-48 rounded-md shadow-lg bg-white ring-1 ring-black ring-opacity-5 divide-y divide-gray-100">
                            {item.reference_id && (
                              <button 
                                onClick={() => navigate(`/dashboard/message/${item.reference_id}`)}
                                className="w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-50"
                              >
                                Go to messages
                              </button>
                            )}
                            <button 
                              onClick={() => declinedClickHandle(item, item.demo_id)}
                              className="w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-50"
                            >
                              Cancel demo
                            </button>
                          </div>
                      )}
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}

    {showDeclinedPopup &&
     (
      <div>
        <BuyerDecline
          showDeclinedPopup={showDeclinedPopup}
          setShowDeclinedPopup={setShowDeclinedPopup}
          role='Buyer'
          buyerDeclinedReasons={buyerDeclinedReasons}
          currentDemo={currentDemo}
          setCurrentDemo={setCurrentDemo}
          demos={demos}
          setDemos={setDemos}
          source='Cancel'
        />
      </div>
    )}

    {showReschedule && (
      <>
        <div className='overlay'>
            <div className='modal modal--pad0 modal--wide'>
              {/* {currentDemo.booking_style === 'daily_view' && (
                <RescheduleTimes demo={currentDemo} demos={demos} setDemos={setDemos} demo_id={currentDemo.demo_id} company_name={currentDemo.company_name} seller_id={currentDemo.seller_id} showSteps={true} setShowReschedule={setShowReschedule} enableReason={false} />
              )} */}

                <SubmitReschedule demo={currentDemo} demos={demos} setDemos={setDemos} demo_id={currentDemo.demo_id} company_name={currentDemo.company_name} seller_id={currentDemo.seller_id} showSteps={true} setShowReschedule={setShowReschedule} enableReason={false} />
            
            </div>
        </div>
      </>
    )}
    </>
  )
}

export default BuyerDemosRescheduled;